


































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { virtualMachineDetailsService } from '@/components/virtual-machine-edit/services/VirtualMachineDetailsService';
import { format } from 'date-fns';
import { mapState } from 'vuex';
import { storeService } from '@/services/StoreService';

@Component({
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class VirtualMachineSnapshot extends Vue {
  workspaceId = 0;
  regionId = 0;
  virtualMachineId = 0;
  snapshot = {};
  isCreateSnapshotModalShown = false;
  isRestoreSnapshotModalShown = false;
  isRemoveSnapshotModalShown = false;
  machineState = '';
  isLoading = false;

  @Watch('$store.state.snapshot.snapshots', { immediate: true, deep: true })
  onSnapshotsChange() {
    this.snapshot = this.$store.getters['snapshot/getSnapshotByVirtualMachineId'](this.virtualMachineId);
  }

  @Watch('$store.state.virtualMachines.virtualMachines', { immediate: true, deep: true })
  onMachinesChange() {
    if (this.virtualMachineId) {
      const machineData = this.$store.getters['virtualMachines/getMachine'](this.virtualMachineId);
      this.machineState = machineData.state || '';
    }
  }

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy  HH:mm') : '';
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    this.getSnapshot();
    virtualMachineDetailsService
      .getSnapshot(this.workspaceId, this.regionId, this.virtualMachineId)
      .then((data: any) => {
        this.snapshot = data;
      });
    const machineData = this.$store.getters['virtualMachines/getMachine'](this.virtualMachineId);
    this.machineState = machineData.state || '';
  }
  onCloseCreate() {
    this.isCreateSnapshotModalShown = false;
  }
  onCloseRestore() {
    this.isRestoreSnapshotModalShown = false;
  }
  onCloseRemove() {
    this.isRemoveSnapshotModalShown = false;
  }
  getSnapshot() {
    storeService.getSnapshot(this.virtualMachineId);
  }
  create() {
    this.snapshot = {};
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .createSnapshot(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.getSnapshot();
        this.onCloseCreate();
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  restore() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .restoreSnapshot(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.onCloseRestore();
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  remove() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .deleteSnapshot(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.snapshot = {};
        this.onCloseRemove();
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
